import { Grid } from '@mui/material';
import { createSearchParams, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';

import { AvatarImage } from '../../components/Avatar';
import { INVITE_TOKEN, INVITE_WORKSPACE_NAME } from '../../constants/common';
import { WORKSPACE_INVITE_LOGIN } from '../../constants/routes';
import Button from '../../components/atoms/button';
import useAuth from '../../context/AuthContext';
import useWorkspaceInvite from '../../context/WorkspaceInviteContext';

const getParamsFromUrl = (url, key) => new URLSearchParams(url).get(key);

const WorkspaceInvitationItem = ({ invitation, isLastItem }) => {
  // init
  const { authUser: { email } } = useAuth();
  const { setIsInviteUser } = useWorkspaceInvite();
  const { name, logo, workspaceMembers } = invitation.workspaceMetadata;
  const navigate = useNavigate();

  const handleOnJoinClick = () => {
    const token = getParamsFromUrl(invitation.link.split('?')[1], INVITE_TOKEN);
    if (token) {
      navigate({
        pathname: `/${WORKSPACE_INVITE_LOGIN}`,
        search: createSearchParams({ [INVITE_TOKEN]: token, [INVITE_WORKSPACE_NAME]: name, email }).toString(),
      });
      setIsInviteUser(true);
    }
  };

  return (
    <Grid container>
      <Grid item xs={1} sx={{ display: 'flex', alignItems: 'center' }}>
        <AvatarImage alt="Workspace Logo" src={logo} borderGray whiteAvatar initials={1} fontWeight={600} fontSize={22} height={50} width={50} name={name} />
      </Grid>
      <Grid item xs={11} container paddingTop={1.5} paddingBottom={1.5} sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', borderBottom: isLastItem ? '' : '1px solid #EAECF0' }}>
        <Grid direction="column" item container>
          <div style={{ display: 'flex', justifyContent: 'space-between' }}>
            <div className="item-workspace-invite">
              <p className="item-workspace-name">{name}</p>
              <p className="item-workspace-description">from {invitation.createdByEmail} | {workspaceMembers} {workspaceMembers > 1 ? 'members' : 'member'}</p>
            </div>
            <Button className="workspace-open-or-join-button" onClick={handleOnJoinClick} primary small outlined>Join</Button>
          </div>
        </Grid>
      </Grid>
    </Grid>
  );
};

WorkspaceInvitationItem.propTypes = {
  invitation: PropTypes.shape({
    link: PropTypes.string.isRequired,
    createdByEmail: PropTypes.string.isRequired,
    workspaceMetadata: PropTypes.shape({
      name: PropTypes.string,
      logo: PropTypes.string,
      workspaceMembers: PropTypes.number,
    }),
  }),
  isLastItem: PropTypes.bool.isRequired,
};

export default WorkspaceInvitationItem;
